class arnCustom {
	constructor(){
// 		document.body.classList.add('test_1');
// 		document.body.classList.add('test_2');
		this.slideBanner();
		this.addCart();
		this.filterEvents();
	}

	slideBanner(){
		let slide = $('.arn-trust .arn-trust-slide');

		slide.length && slide.slick({
			autoplay: false,
			dots: false,
			arrows: false,
			slidesToShow: 4,
			slidesToScroll: 4,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      variableWidth: false,
                      infinite: true,
                      autoplay: true,
                      autoplaySpeed: 2000
					}
				}
			]
		});
	}


	addCart(){
		let btn = $('.template-product .product-form__cart-submit');
		if(!btn.length) return;

		btn.on('click', function(e){
			e.preventDefault();
			let form = btn.closest('form')[0];
			let formData = new FormData(form);

			fetch('/cart/add.js', {
				method: 'POST',
				body: formData
			})
			.then(response=>{
				fetch('/cart.js').then(cart=>cart.json()).then(e=>{
					setCartCountValue(e.item_count, e.total_price)
					refreshAjaxCart();

					$('header .js__cart-toggle').length && $('header .js__cart-toggle').trigger('click');
				})

			})
			.catch((error) => {
				console.error('Error:', error);
			});

		})
	}


	filterEvents(){
		let this2 = this;
		this.filterArray = [];

		$(document).on('click', '.filter-menu .filter-group li a', function(e){
			e.preventDefault();
			let this4 = $(this);
			let li = this4.closest('li');
			li.toggleClass('selected');
		})

		$(document).on('click', '.btn-filter-apply', function(e){
			e.preventDefault();

			let activeFilter = $('.filter-menu .selected');
			let currentCollection = this.dataset.baseUrl.trim();
			let collectionURL = this.dataset.url;
			let newURL = '';

			if(!activeFilter.length){
				return;
			}

			activeFilter.length && activeFilter.each((i, v)=>{
				let tag = v.dataset.tag;
				!this2.filterArray.includes(tag) && this2.filterArray.push(tag);
			})


			if(activeFilter.length > 1){
              if(currentCollection.length){
                let newArray = this2.filterArray.filter(i=> i != currentCollection).join('+');
				newURL = collectionURL.replace('all', currentCollection) + '/' + newArray;
              }
              else{
				newURL = collectionURL.replace('all', this2.filterArray.join('+').replace('+', '/'));
              }
			}
			else{
				newURL = collectionURL.replace('all', this2.filterArray[0]);
			}

			this.innerHTML = 'LOADING...';
			this2.fetchData(newURL);
			this2.filterArray = [];
		})
	}

  fetchData(url){
    fetch(url+'?section_id=collection-template').then(e=>e.text()).then(e=>{
    	window.history.replaceState({ path: url }, '', url);

    	let div = document.createElement('div');
    	let className = ['#Collection', '.collection-filter', '.collection-header'];

    	div.innerHTML = e;
    	className.forEach(i=>{
    		div.querySelector(i) && document.querySelector(i).replaceWith(div.querySelector(i));
    	})

    	if ($( window ).width() <= 767) {
    		window.scrollTo(0, 0);
    		$('.filter-menu .filter-group').not('.has_group_selected').addClass('expanded').find('h4, .filter-clear').show();
    		$(".outer").css({"height":"none", "overflow":"auto"});
    	}

    })
  }
}

window.addEventListener('DOMContentLoaded', function(){
	new arnCustom();
})